import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-topic-sidebar',
  templateUrl: './topic-sidebar.component.html',
  styleUrls: ['./topic-sidebar.component.css']
})
export class TopicSidebarComponent implements OnInit {

  @Input() currentTopicIndex: number;
  @Input() TopicSummaryData: any;
  @Input() completedCount;
  @Output() topicSelected: EventEmitter<any> = new EventEmitter<any>();
  @Input() selectedFlashCardData:any;
  @Input() isRevisionQuestionsCompleted:any;
  @Input() taggedQuestionIds:any;

  completedSummary;

  constructor() { }

  ngOnInit(): void {
    console.log('isRevisionQuestionsCompleted',this.isRevisionQuestionsCompleted)
    this.completedSummary = [];
    this.TopicSummaryData.forEach(element => {
      if (element.completed){
        this.completedSummary.push(element);
      }
    });
  }

  selectTopicFromTopiclist(index){
    this.topicSelected.emit(index);
  }

  

}
